export default __webpack_public_path__ + "static/sns-twitter-1fe61814241c191fff4cdaf20e43a725.svg";